import React, { useState } from 'react';
import styled from 'styled-components';
import { Row, Col } from 'reactstrap';
import { RebelTitle, RebelSubtitle, RebelColors } from '../../../styles/rebel-experiences';
import RebelSettingsList from './rebel-settings-list';

const RebelSettings = (props) => {
    const [activeTab, setActiveTab] = useState('properties');

    return (
        <PageContainer>
            <Row>
                <Col style={{textAlign: "center"}}>
                    <RebelTitle>
                        R.E.B.E.L Config
                    </RebelTitle>
                    <RebelSubtitle>
                        Refined Elite Business & Executive Leisure Configuration
                    </RebelSubtitle>
                </Col>
            </Row>

            <TabContainer>
                <TabButton
                    active={activeTab === 'properties'}
                    onClick={() => setActiveTab('properties')}
                >
                    Properties
                </TabButton>
                <TabButton
                    active={activeTab === 'config'}
                    onClick={() => setActiveTab('config')}
                >
                    Config
                </TabButton>
            </TabContainer>

            <RebelSettingsList activeTab={activeTab} />
        </PageContainer>
    )
}

export default RebelSettings;

const PageContainer = styled.div`
    padding: 30px 15px;
    height: 100%;
    box-sizing: border-box;
`;

const TabContainer = styled.div`
    display: flex;
    gap: 8px;
    margin: 24px 15px 0 15px;
    border-bottom: 2px solid ${RebelColors.border};
    padding-bottom: 0;
`;

const TabButton = styled.button`
    background: ${props => props.active ? RebelColors.gold : 'transparent'};
    color: ${props => props.active ? '#000000' : RebelColors.primary};
    border: none;
    border-radius: 8px 8px 0 0;
    padding: 12px 24px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    bottom: -2px;
    border-bottom: 2px solid ${props => props.active ? RebelColors.gold : 'transparent'};

    &:hover {
        background: ${props => props.active ? RebelColors.gold : RebelColors.surfaceLight};
        color: ${props => props.active ? '#000000' : RebelColors.primary};
    }
`;